import React from "react";

// Page sizes offered on the listing pages. The server rejects anything not in
// this list and falls back to 10, so keep the two in step
// (functions/manufacturer-list/helpers/helper.js -> ALLOWED_PAGE_SIZES).
export const PAGE_SIZES = [5, 10, 20, 30, 50];

function PageSizeSelect({ value, onChange }) {
  return (
    <div className="page-size-select">
      <label htmlFor="page-size">Show</label>
      <select
        id="page-size"
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
      >
        {PAGE_SIZES.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
      <span>per page</span>
    </div>
  );
}

export default PageSizeSelect;
